__turbopack_context__.v({
  "container": "gltf-package-upload-module__86pxMq__container",
  "content": "gltf-package-upload-module__86pxMq__content",
  "filesSummary": "gltf-package-upload-module__86pxMq__filesSummary",
  "form": "gltf-package-upload-module__86pxMq__form",
  "formContainer": "gltf-package-upload-module__86pxMq__formContainer",
  "helpText": "gltf-package-upload-module__86pxMq__helpText",
  "helpTextBlock": "gltf-package-upload-module__86pxMq__helpTextBlock",
  "infoSection": "gltf-package-upload-module__86pxMq__infoSection",
  "infoText": "gltf-package-upload-module__86pxMq__infoText",
  "input": "gltf-package-upload-module__86pxMq__input",
  "inputForm": "gltf-package-upload-module__86pxMq__inputForm",
  "summaryGrid": "gltf-package-upload-module__86pxMq__summaryGrid",
  "title": "gltf-package-upload-module__86pxMq__title",
  "upload": "gltf-package-upload-module__86pxMq__upload",
  "uploadContent": "gltf-package-upload-module__86pxMq__uploadContent",
});
